import { Trophy } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { getCategoryName } from '../utils/categoryNames';

/**
 * Top seller badge — category-based trust signal.
 *
 * Rendered inline next to the seller's name on the profile header.
 * Server-computed via `user_profile.top_category_badge` — the component
 * just maps it to a small chip; no client-side recomputation.
 *
 * Criteria (enforced in backend/routes/reviews.py):
 *   >= 3 listings in category, >= 3 reviews, avg rating >= 4.5.
 */
export const TopSellerBadge = ({ badge, compact = false }) => {
  const { t } = useTranslation();
  if (!badge || !badge.category) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-warning bg-warning-soft text-warning ${
        compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs'
      }`}
      title={`${badge.average_rating} ★ · ${badge.review_count} ${t('review.reviews')}`}
      data-testid="top-seller-badge"
    >
      <Trophy size={compact ? 11 : 13} weight="fill" className="text-warning" />
      <span className="font-medium whitespace-nowrap">
        {t('profile.topSellerBadge', { category: getCategoryName(badge.category, t) })}
      </span>
    </span>
  );
};
